(() => {
  if (window.__sokProductAnchorScrollLoaded) return;
  window.__sokProductAnchorScrollLoaded = true;

  const safeId = (value) => String(value || '').replace(/[^a-zA-Z0-9_-]/g, '-');

  const initRoot = (root) => {
    if (!root || root.dataset.sokAnchorReady === 'true') return;
    const nav = root.querySelector('.sok-product-tabs');
    const panels = Array.from(root.querySelectorAll('[data-sok-panel]'));
    if (!nav || !panels.length) return;

    root.dataset.sokAnchorReady = 'true';
    nav.removeAttribute('role');
    nav.setAttribute('role', 'navigation');
    nav.setAttribute('aria-label', 'Product details navigation');

    const rootKey = safeId(root.id || 'SokProductDetails');
    const panelByName = new Map();

    panels.forEach((panel, index) => {
      const name = panel.getAttribute('data-sok-panel') || `section-${index + 1}`;
      panel.hidden = false;
      panel.removeAttribute('hidden');
      panel.dataset.sokAnchorSection = name;
      if (!panel.id) panel.id = `${rootKey}-${safeId(name)}`;
      panelByName.set(name, panel);
    });

    Array.from(nav.querySelectorAll('[data-sok-tab]')).forEach((oldTab) => {
      const name = oldTab.getAttribute('data-sok-tab');
      const panel = panelByName.get(name);
      if (!panel) return;
      const link = document.createElement('a');
      link.className = `${oldTab.className} sok-product-anchor-link`;
      link.classList.remove('sok-product-tab');
      link.dataset.sokAnchor = name;
      link.href = `#${panel.id}`;
      link.innerHTML = oldTab.innerHTML;
      if (oldTab.classList.contains('is-active')) link.setAttribute('aria-current', 'location');
      oldTab.replaceWith(link);
    });

    const links = Array.from(nav.querySelectorAll('[data-sok-anchor]'));
    if (!links.length) return;
    let activeName = '';
    let ticking = false;

    const keepActiveVisible = (link) => {
      const navRect = nav.getBoundingClientRect();
      const linkRect = link.getBoundingClientRect();
      if (linkRect.left < navRect.left || linkRect.right > navRect.right) {
        const targetLeft = link.offsetLeft - (nav.clientWidth - link.offsetWidth) / 2;
        nav.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
    };

    const setActive = (name, ensureVisible = true) => {
      if (!name || name === activeName) return;
      activeName = name;
      links.forEach((link) => {
        const active = link.dataset.sokAnchor === name;
        link.classList.toggle('is-active', active);
        if (active) {
          link.setAttribute('aria-current', 'location');
          if (ensureVisible) keepActiveVisible(link);
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const updateActive = () => {
      ticking = false;
      const sticky = root.querySelector('.sok-product-tabs-wrap');
      const marker = (sticky ? sticky.getBoundingClientRect().bottom : 0) + 28;
      let current = panels[0];
      panels.forEach((panel) => {
        if (panel.getBoundingClientRect().top <= marker) current = panel;
      });
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
        current = panels[panels.length - 1];
      }
      setActive(current.dataset.sokAnchorSection);
    };

    const queueActive = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateActive);
    };

    nav.addEventListener('click', (event) => {
      const link = event.target.closest('[data-sok-anchor]');
      if (!link || !nav.contains(link)) return;
      const panel = panelByName.get(link.dataset.sokAnchor);
      if (!panel) return;
      event.preventDefault();
      setActive(link.dataset.sokAnchor);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      panel.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', `#${panel.id}`);
    });

    window.addEventListener('scroll', queueActive, { passive: true });
    window.addEventListener('resize', queueActive);
    requestAnimationFrame(updateActive);

    if (location.hash) {
      const hashTarget = document.getElementById(location.hash.slice(1));
      if (hashTarget && root.contains(hashTarget)) {
        requestAnimationFrame(() => hashTarget.scrollIntoView({ block: 'start' }));
      }
    }
  };

  const init = (scope = document) => {
    if (scope.matches && scope.matches('.sok-product-details')) initRoot(scope);
    scope.querySelectorAll?.('.sok-product-details').forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
